import React, { useState, useEffect } from 'react';
import '../css/Project.css';
import '../css/Collab.css';
import strykCover from '../assets/stryk-cover.webp';
import buxCover from '../assets/bux-cover.webp';
import wonderkindCover from '../assets/wonderkind-cover.webp';

import ButtonLarge from '../components/Button-large';
import '../css/Buttons.css';
import Project from '../components/Projects';
import ProjectStryk from './ProjectStryk';
import ProjectBuxZero from './ProjectBuxZero';
import ProjectWonderkind from './ProjectWonderkind';

import { Shape1, ShapeRectangle, Shape3 } from '../components/Shapes';
import {
  MdArrowForward,
  MdBuild,
  MdNavigation,
  MdPersonAddDisabled,
  MdChat,
  MdLocalCafe,
  MdViewQuilt,
  MdImageSearch,
  MdFlashOn,
  MdBakeryDining,
  MdTextFields,
  MdHandshake,
  MdShare,
} from 'react-icons/md';
import collabLogo from '../assets/collab-logos/logo-cc-amstel.svg';
import ProductCard from '../components/ProductCard';

import bananaBread from '../assets/banana-bread.webp';
import blueberryCookie from '../assets/blueberry-cookie.webp';
import chocolateChipCookie from '../assets/chocolate-chip-cookie.webp';
import basqueCheesecake from '../assets/basque-cheesecake.webp';
import paoDeQueijo from '../assets/pao-de-queijo.webp';
import cheeseScone from '../assets/cheese-scone.webp';
import emptyImage from '../assets/empty-image.webp';
import lemonPoppySeedLoaf from '../assets/lemon-poppy-loaf.webp';
import veganIcon from '../assets/vegan-icon.svg';
import glutenFreeIcon from '../assets/gluten-free-icon.svg';

// If the image is not appearing, check that '../assets/banana-bread.png' exists and is spelled correctly.
// If using create-react-app, only .png, .jpg, .jpeg, .gif, .webp, .svg are supported in imports.

const CollabCCAmstel = ({}) => {
  useEffect(() => {
    const elements = document.querySelectorAll('.move-right, .move-left');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const [isProjectVisible, setIsProjectVisible] = useState(false);

  const handleButtonClick = () => {
    setIsProjectVisible(!isProjectVisible); // Toggle visibility
  };

  return (
    <div className="homepage">
      {/* Hero Section */}
      <header className="intro">
        <div className="shapes-container-inside blur-desktop blur-mobile">
          <ShapeRectangle className="shape shape-5" />
          <Shape3 className="shape shape-6" />
        </div>

        <div className="hero">
          <div className="collab-logo">
            <div className="collab-plus-sign">+</div>
            <img src={collabLogo} alt="CC Amstel Logo" />
          </div>
          <h1>Collaboration proposal</h1>
        </div>
      </header>

      <div className="shapes-container-outside">
        <Shape1 className="shape shape-1" />
        <ShapeRectangle className="shape shape-2" />
        <Shape3 className="shape shape-3" />
        <Shape1 className="shape shape-4" />
      </div>

      {/* End of Hero Section */}

      <section className="section-intro">
        <div className="challenges-content">
          <p>
Chunks is an Amsterdam-based baking brand crafting fresh, handcrafted pastries and baked goods using locally sourced ingredients whenever possible and careful, small-batch techniques. We’re excited about a possible collaboration with <br/><strong>CC Amstel</strong> our neighbourhood’s cultural club house and theatre café, because our shared focus on community, creativity, and quality hospitality aligns so well. Together, we can bring people closer through thoughtful food and the warm, welcoming atmosphere that defines CC Amstel.

          </p>
        </div>
      </section>

      {/* Shared goals section */}
      <section className="solutions">
        <div className="solutions-grid">
          <div className="section-header">
            <h2>Shared goals</h2>
          </div>

          <div className="solutions-row-left move-right blue-background">
  <div className="solutions-icon">
    <MdLocalCafe size={48} />
  </div>
  <div className="solutions-content">
    <h3>Enriched café experience</h3>
    <p>
      Complement CC Amstel’s welcoming café atmosphere with fresh, handcrafted baked goods made locally and designed to pair perfectly with their community vibe.
    </p>
  </div>
</div>

<div className="solutions-row-right move-left blue-background">
  <div className="solutions-icon">
    <MdShare size={48} />
  </div>
  <div className="solutions-content">
    <h3>Local connections</h3>
    <p>
      Build meaningful ties between neighbourhood businesses through collaboration, creativity, and shared commitment to local producers and quality experiences.
    </p>
  </div>
</div>

<div className="solutions-row-left move-right blue-background">
  <div className="solutions-icon">
    <MdHandshake size={48} />
  </div>
  <div className="solutions-content">
    <h3>Strengthened brand perception</h3>
    <p>
      Enhance both brands through authentic collaboration, cross-promotion, and shared visibility rooted in community and creativity.
    </p>
  </div>
</div>


          <div className="solutions-description">
            <p>
              A partnership with Chunks would let CC Amstel broaden its menu offering:
              customers come not just for the local library relaxed experience, but for a complementary handcrafted treat. This can elevate
              your café as a destination for both cultural and food experiences: increasing dwell time, customer
              satisfaction, and average spend.
            </p>
          </div>
        </div>
      </section>

      {/* Product offering Section */}
      <section className="case-studies">
        <div className="case-studies-grid">
          <div className="section-header">
            <h2>Product offering</h2>
          </div>

          <div className="cases">
           <ProductCard
              productImage={bananaBread}
              productTitle="Banana Bread"
              isVegan={true}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="Moist, flavorful and vegan banana bread made with ripe bananas, candied walnuts and dark chocolate."
              extraInfo="Gluten free option available"
            />

            <ProductCard
              productImage={lemonPoppySeedLoaf}
              productTitle="Lemon Poppy Seed Loaf"
              isVegan={true}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="Moist, flavorful and vegan lemon poppy seed loaf covered in a sweet lemon glaze."
              extraInfo="Gluten free option available"
            />

            <ProductCard
              productImage={basqueCheesecake}
              productTitle="Basque Burnt Cheesecake"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="Soft, creamy cheesecake with a caramelized top and a rich, velvety texture."
              extraInfo=""
            />

          </div>


          <div className="cases">

            <ProductCard
              productImage={blueberryCookie}
              productTitle="Blueberry Macadamia Cookies"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per cookie"
              wholesalePrice="€24.00"
              wholesaleUnit="per batch (24 frozen cookies)"
              description="Cakey, buttery cookies with roasted macadamia nuts, white chocolate and blueberry swirl."
              extraInfo=""
            />

            <ProductCard
              productImage={emptyImage}
              productTitle="Chocolate Hazelnut Cookies"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per cookie"
              wholesalePrice="€24.00"
              wholesaleUnit="per batch (24 frozen cookies)"
              description="Cakey, buttery cookies with roasted macadamia nuts, white chocolate and blueberry swirl."
              extraInfo=""
            />

            <ProductCard
              productImage={chocolateChipCookie}
              productTitle="Chocolate Chip Cookies"
              isVegan={true}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="A perfect mix between crunchy and chewy, with a deep dark chocolate flavour."
              extraInfo="Gluten free option available"
            />

            
          </div>

          <div className="cases">
           <ProductCard
              productImage={paoDeQueijo}
              productTitle="Brazilian Cheese Bread"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="Moist, flavorful and vegan lemon poppy seed loaf covered in a sweet lemon glaze."
              extraInfo=""
            />

            <ProductCard
              productImage={cheeseScone}
              productTitle="Cheese scones"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per cookie"
              wholesalePrice="€24.00"
              wholesaleUnit="per batch (24 frozen cookies)"
              description="Cakey, buttery cookies with roasted macadamia nuts, white chocolate and blueberry swirl."
              extraInfo=""
            />

            <ProductCard
              productImage={emptyImage}
              productTitle="Sample text"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="A perfect mix between crunchy and chewy, with a deep dark chocolate flavour."
              extraInfo="Gluten free option available"
              hidden={true}
            />
          </div>

          


          

            
        </div>
      </section>

      <section className="outro">
        <div className="hero-outro">
          <h1>Thanks!</h1>
        </div>
      </section>
    </div>
  );
};

export default CollabCCAmstel;
